import React from 'react';
import NeighborhoodPainPost from '../components/NeighborhoodPainPost';

const BlogPostCarmichaelPain = () => (
  <NeighborhoodPainPost
    data={{
      neighborhood: 'Carmichael',
      slug: 'back-and-neck-pain-massage-carmichael',
      image:
        'https://images.unsplash.com/photo-1620733723572-11c53f73a416?w=1600&auto=format&fit=crop&q=80',
      driveMinutes: '20–25 minutes',
      driveNote:
        'the drive from Carmichael to 2528 I Street via Business 80 or Fair Oaks Boulevard is straightforward, especially outside of rush hour',
      routes: [
        'From central Carmichael: ~20 minutes via Fair Oaks Boulevard and Business 80',
        'From Del Campo / Manzanita area: ~22–25 minutes via Business 80',
        'From near Ancil Hoffman Park: ~20 minutes via Fair Oaks Boulevard',
      ],
      nearbyAreas: [
        'Carmichael',
        'Fair Oaks',
        'Arden-Arcade, Sacramento',
        'Citrus Heights',
        'Midtown Sacramento',
      ],
      pageTitle:
        'Back and Neck Pain Massage in Carmichael | Ayumi Suzuki',
      hookLine:
        'Carrying chronic back or neck pain and searching for a certified massage therapist near Carmichael?',
      dataTestId: 'carmichael-pain-blog-page',
    }}
  />
);

export default BlogPostCarmichaelPain;
